import axios from 'axios';
import { fetchSubadminsSuccess, fetchSubadminsFailure } from './userSlice'; // Import actions
import { API_BASE_URL } from '../config/config';

export const fetchSubadmins = () => async (dispatch, getState) => {
  try {
    const { token } = getState().user; // Get token from Redux state

    const response = await axios.get(`${API_BASE_URL}api/users/subadmins`, {
      headers: { Authorization: `Bearer ${token}` }, // Send JWT for authorization
    });

    if (response.data && response.data.subadmins) {
      // Dispatch the fetched subadmins to Redux store
      dispatch(fetchSubadminsSuccess(response.data.subadmins));
    } else {
      throw new Error("Invalid response format");
    }
  } catch (error) {
    // Dispatch failure action with error message
    dispatch(fetchSubadminsFailure(error.response?.data?.message || 'Failed to fetch Subadmins'));
  }
};  
